import { OrganizationKeyName } from "../../../model/Organization";
import { GetProductListActionFilters } from "../model/GetProductListActionFilters";

export const GET_PRODUCT_LIST_FAIL = "SHOP:GET_PRODUCT_LIST_FAIL";

export const getProductListFailAction = (
  organization: OrganizationKeyName,
  filters: GetProductListActionFilters
) => ({
  type: GET_PRODUCT_LIST_FAIL as typeof GET_PRODUCT_LIST_FAIL,
  organization,
  filters,
});

export type GetProductListFailAction = ReturnType<
  typeof getProductListFailAction
>;
